/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * New uses of this type are discouraged because of difficulty describing its usage when embedded in APIs.
 * 1. Invalid usage help.  It is impossible to add specific help for individual usage.  In most embedded usages, there are particular
 * restrictions like, "must refer only to types A and B" or "UID not honored" or "name must be restricted".
 * Those cannot be well described when embedded.
 * 2. Inconsistent validation.  Because the usages are different, the validation rules are different by usage, which makes it hard for users to predict what will happen.
 * 3. The fields are both imprecise and overly precise.  Kind is not a precise mapping to a URL. This can produce ambiguity
 * during interpretation and require a REST mapping.  In most cases, the dependency is on the group,resource tuple
 * and the version of the actual struct is irrelevant.
 * 4. We cannot easily change it.  Because this type is embedded in many locations, updates to this type
 * will affect numerous schemas.  Don't make new APIs embed an underspecified API type they do not control.
 * 
 * Instead of using this type, create a locally provided and used type that is well-focused on your reference.
 * For example, ServiceReferences for admission registration: https://github.com/kubernetes/api/blob/release-1.17/admissionregistration/v1/types.go#L533 .
 * +structType=atomic
 * @export
 * @interface V1TypedLocalObjectReference
 */
export interface V1TypedLocalObjectReference {
    /**
     * APIGroup is the group for the resource being referenced.
     * If APIGroup is not specified, the specified Kind must be in the core API group.
     * For any other third-party types, APIGroup is required.
     * +optional
     * @type {string}
     * @memberof V1TypedLocalObjectReference
     */
    apiGroup?: string;
    /**
     * Kind is the type of resource being referenced
     * @type {string}
     * @memberof V1TypedLocalObjectReference
     */
    kind?: string;
    /**
     * Name is the name of resource being referenced
     * @type {string}
     * @memberof V1TypedLocalObjectReference
     */
    name?: string;
}

export function V1TypedLocalObjectReferenceFromJSON(json: any): V1TypedLocalObjectReference {
    return V1TypedLocalObjectReferenceFromJSONTyped(json, false);
}

export function V1TypedLocalObjectReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1TypedLocalObjectReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'apiGroup': !exists(json, 'apiGroup') ? undefined : json['apiGroup'],
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function V1TypedLocalObjectReferenceToJSON(value?: V1TypedLocalObjectReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'apiGroup': value.apiGroup,
        'kind': value.kind,
        'name': value.name,
    };
}

